module.exports = __webpack_public_path__ + "img/Fav_merchants.ebbe8ac4.png";